export const IS_BROWSER = typeof window !== 'undefined';

export const NEWSLETTER_URL =
  'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

export const NEWSLETTER_LIST_ID = 'KADWX6';
